import Vue from 'vue'
import R from 'ramda'
import debounce from 'lodash.debounce'
import tap from 'tap-logger'
import { fontSizer, selectSlider, $getFontSize } from '../../theme-helpers'
import StickerMessagePreview from '../components/sticker-message-preview.vue'

const toSlug = R.pipe(
	maybeString => typeof maybeString === 'string' ? maybeString : '',
	R.split('-'),
	R.join('_')
)

export const singleApplicationVue = {
	el: '#single-application-vue',
	components: {StickerMessagePreview},
	data: {
		sticker_text_1: '',
		sticker_text_2: '',
		selects: {
			designsSelect: {},
			formsSelect: {},
			templatesSelect: {},
			fontsSelect: {},
		},
		selectedDesign: {},
		selectedForm: {},
		selectedTemplate: {},
		selectedLabel: {},
		formsCache: {},
		someCache: {},
		loadedFonts: [],
		sticker_col_styles: {// de los stickers que se muestran del lado derecho, para editar editar el texto
			height: 0,
			width: 0
		},
		quantity: '',
		fontSizes: {}
	},

	computed: {
		availableForms() {
			let key = toSlug(R.path(['selectedDesign', 'slug'], this))
			return R.pathOr([], ['formsCache', key], this)
		},

		stickerText() {//concatenamos para correr el watcher
			return this.sticker_text_1 + this.sticker_text_2
		},

		selectedFont() {
			return R.pathOr('', ['selectedLabel', 'font', 'google_label'], this)
		},

		selectedSku() {
			return R.pathOr({}, ['selectedLabel', 'sku'], this)
		}
	},

	methods: {
		pathOr: R.pathOr,

		isEmpty: R.isEmpty,

		getThumbnail: obj => R.pathOr('', ['thumbnail_image', 'url'], obj) || '/images/not-available.png',

		getAlt: R.path( ['thumbnail_image', 'alt']),

		getTitle: R.path( ['thumbnail_image', 'title']),

		selectDesign(design) {
			this.selectedDesign = design
			if(this.formsCache[toSlug(design.slug)]) {
				//no hacemos nada porque availableForms se encarga de eso
				return
			}
			this.getForms(design)
		},

		getForms(design) {
			this.$http.get(design.public_url)
				.then(R.pathOr([], ['body']))
				.then(collection => {
					this.$set(`formsCache.${toSlug(design.slug)}`, collection)
					//al agregar los datos al cache, availableForms se encarga de mostrarlas
					return collection
				})
				.catch(this.$root.ajaxErrAlerting)
		},

		selectForm(form) {
			this.selectedForm = form
		},

		selectTemplate(template) {
			this.selectedTemplate = template
		},

		selectLabel(label) {
			this.selectedLabel = label
		},

		selectedClass(elem, selectedElem) {
			return R.equals(elem, selectedElem)
				? 'selected'
				: ''
		},

		resizeFont: debounce(function() {
			if(0 === R.pathOr(0, ['selectedTemplate', 'stamps', 'length'], this)) {return}
			this.$broadcast('resize-font')//delegamos resizeFont a los hijos, porque pueden tener contenedores de tamaño distinto
		}, 70),

		addToCart() {

			let data = {
				stamps: this.fontSizes,
				texts: [this.sticker_text_1, this.sticker_text_2],
				sku: this.selectedSku.sku,
				quantity: this.quantity,
				_token: this.store.csrf_token,
			}

			let validation = R.pipe(
				R.mapObjIndexed((elem, key) => (elem === '' && key !== 'sticker_text_2') || elem === undefined ||  elem === '0'
					? {
						sticker_text_1: 'Es necesario agregar un texto a la estampa',
						sticker_text_2: 'Es necesario agregar un texto a la estampa',
						sku: 'Es necesario elegir diseño, forma, color y fuente',
						quantity: 'Es necesario elegir una cantidad mayor a 0'
					}[key]
					: ''
				),
				R.values,
				R.reject(R.isEmpty),
			)(data)

			if(validation.length > 0) {
				this.alertError(validation)
				return
			}

			this.$http.post(this.store.routes.addToCart.post, data)
				.then(R.pathOr({}, ['body']))
				.then(body => {
 					this.store.cart.data = body.data
					this.alert(body)
				})
				.catch(this.$root.ajaxErrAlerting)

		},
	},

	watch: {
		//Cuando se selecciona un Diseño, siempre que sea posible (cuando los elementos existan), se seleccionara el primer elemento de cada uno de los selects
		'store.designs.data': {
			initial: true,
			handler: function() {
				if(R.pathOr([], ['store', 'designs', 'data', 'length'], this) > 0) {
					this.designsSelect = selectSlider('#designs_select_JS')
					this.selectDesign(this.store.designs.data[0])
				}
			}
		},

		availableForms() {
			this.formsSelect = selectSlider('#forms_select_JS')
			this.selectForm(R.pathOr({}, ['availableForms', 0], this))
		},

		selectedForm() {
			Vue.nextTick(() => {
				this.templatesSelect = selectSlider('#templates_select_JS')
				this.selectTemplate(R.pathOr({}, ['selectedForm', 'templates', 0], this))
			})
		},

		selectedTemplate() {
			this.loadedFonts = R.pipe(
				R.pathOr([], ['labels']),
				R.map(R.path(['font', 'google_url'])),
				R.reject(R.isEmpty),
				R.concat(this.loadedFonts),
				R.uniq,
			)(this.selectedTemplate)

			Vue.nextTick(() => {
				this.selects.fontsSelect = selectSlider('#fonts_select_JS')
				this.selectLabel(R.pathOr({}, ['selectedTemplate', 'labels', 0], this))
				this.resizeFont()
			})
		},

		stickerText() {
			this.resizeFont()
		},

		selectedFont() {
			this.resizeFont()
		}
	},

	events: {
		'new-font-size'({id, font_size}) {
			let currentStamps = R.map(stamp => stamp.id, R.pathOr([], ['selectedTemplate', 'stamps'], this))
			this.fontSizes = R.pipe(
				R.assoc(id, font_size),
				R.pick(currentStamps),
			)(this.fontSizes)

		}
	}
}
